<template>  
  <div>    
  <b-modal
    id="view-floor-modal"
    title="Floor View Modal"
    centered
    hide-footer
    size="lg"
    :no-close-on-esc="true"
    :no-close-on-backdrop="true"
    @show="onModalShow"
  >
    <div class="text-right mb-1">
      <b-button
        variant="danger"
        pill
        size="md"
        @click="createNewFloor()"
        v-if="hasPermission('create_floor')"
        
      >
        Add Floor
      </b-button>
    </div>
    
    <template #modal-title>
      <h2 class="m-0">View Floors - {{ building.name }}</h2>
    </template>
    <b-table
      responsive="sm"
      :fields="fields"
      :items="floors"
      details-td-class="m-0 p-0"
      small
      v-if="hasPermission('read_floor')"
      :per-page="0"
    >
      <template #cell(building_data)="row">
        {{
          row.item.building_data ? row.item.building_data.name : ""
        }}
      </template>
      
      <template #cell(manage)="row">
        <b-button
          variant="primary"
          pill
          size="sm"
          class="mr-50"
          @click="editFloor(row.item)"
          v-if="hasPermission('update_floor')"
        >
          Edit Floor
        </b-button>

        <b-button
          variant="danger"
          pill
          size="sm"
          class="mr-50"
          @click="downloadImage(row.item.qr_code_image_url)"
          v-if="hasPermission('show_qr_code')"
          :disabled="row.item.qr_code_image_url ? false:true"
        >
          Download QR
        </b-button>
        
        
      </template>
    </b-table>
    <b-pagination
      size="md"
      :total-rows="totalItems"
      v-model="currentPage"
      :per-page="perPage"
    ></b-pagination>
  </b-modal>
  <EditFloorModal
    :floor="floor"
    :key="`editfloor-${editFloorModalCount}`"
  />
  </div>  
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { required } from "@validations";
import util from "@/util.js";
import { quillEditor } from "vue-quill-editor";
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
import EditFloorModal from "@/components/building/EditFloorModal.vue";



export default {
  components: {
    ValidationProvider,
    ValidationObserver,
    quillEditor,
    EditFloorModal, 
  },
  props: { building: Object },
  mixins: [util],
  data() {
    return {
      required,
      fields: [
        { key: "building_data", label: "Building Name" },
        { key: "floor_no", label: "Floor No" },
        { key: "manage", label: "Actions" },
      ],
      currentPage: 1,
      perPage: 0,
      totalItems: 0,
      floor: {},
      floors: [],
      editFloorModalCount: 0,
    };
  },
  methods: {
    ...mapActions({
      getFloors: "appData/getFloors",
    }),
    async fetchPaginatedData() {
      try {
        const res = await this.getFloors({
          pageNumber: this.currentPage,      
          building: this.building.id
        });
        this.floors = res.data.results;
        this.totalItems = res.data.count;
        this.perPage = res.data.per_page;
      } catch (error) {
        this.displayError(error);
      }
    },
    downloadImage(imageUrl) {
      const link = document.createElement('a');
      link.href = imageUrl;
      link.download = 'qr_code_image'; 
      link.click();
    },
    
    editFloor(floor){
      this.floor = floor;
      this.editFloorModalCount += 1;
      this.$nextTick(() => {
        this.$bvModal.show("edit-floor-modal");
      });
      this.$nextTick(() => {
        this.$bvModal.hide("view-floor-modal");
      });
    },
   
    async onModalShow(){
      await this.fetchPaginatedData();
    },
    createNewFloor() {
      this.$emit('createFloor', this.building);
      this.$nextTick(() => {
        this.$bvModal.hide("view-floor-modal");
      });
    },
  },
  computed: {
    ...mapGetters({
      hasPermission: "appData/hasPermission",
    }),
  },
  watch: {
    currentPage: async function (val) {
      await this.fetchPaginatedData();
    },
  },
};
</script>

<style></style>
